import { useEffect, useRef, useState } from 'react'
import { queryCategoryGroupItem } from '@/services/admin/findCooperationSetting'
import ReactDOM from 'react-dom'

export const CATEGORY_QUERY_TYPE = {
    SUP_MAIN: 'SUP_MAIN', // 供应商主营类目
    SUP_SUP: 'SUP_SUP', // 供应商供销类目
    DISTR_MAIN: 'DISTR_MAIN', // 分销商主营类目
    DISTR_DISTR: 'DISTR_DISTR' // 分销商分销类目
}

const defaultCascade = data => {
    const { lv1List, lv2List, lv3List } = data
    const l1 = lv1List?.map(item => item.name) ?? []
    const l2 = lv2List?.map(item => item.name) ?? []
    const l3 = lv3List?.map(item => item.name) ?? []

    return [Array.from(new Set(l1)), Array.from(new Set(l2)), Array.from(new Set(l3))]
}

/*
 * 查询类目级联选项，处理级联
 */
export default (queryType, { first = [], second = [] }: any) => {
    const $cacheFirst = useRef('')
    const $cacheSecond = useRef('')
    const [data, setData] = useState(null)
    const [lv1, setLv1] = useState<any[]>([])
    const [lv2, setLv2] = useState<any[]>([])
    const [lv3, setLv3] = useState<any[]>([])

    const filterData = () => {
        const fStr = (first ?? []).toString()
        const sStr = (second ?? []).toString()

        // 一级二级选中数据没变时不需要重新走逻辑
        if (fStr === $cacheFirst.current && sStr === $cacheSecond.current) {
            return
        }
        $cacheFirst.current = fStr
        $cacheSecond.current = sStr
        if (first.length === 0 && second.length === 0) {
            const [l1, l2, l3] = defaultCascade(data)
            ReactDOM.unstable_batchedUpdates(() => {
                setLv1(l1)
                setLv2(l2)
                setLv3(l3)
            })
            return
        }
        let l2 = []
        let l3 = []
        if (first.length > 0) {
            const { lv2List } = data
            l2 =
                lv2List
                    ?.filter(item => {
                        return first.includes(item.partnerName)
                    })
                    ?.map(item => item.name) ?? []
        }
        if (first.length === 0) {
            const { lv2List } = data
            l2 = lv2List?.map(item => item.name) ?? []
        }
        if (first.length > 0 && second.length === 0) {
            const { lv3List } = data
            l3 =
                lv3List
                    ?.filter(item => {
                        return l2.includes(item.partnerName)
                    })
                    ?.map(item => item.name) ?? []
        }
        if (second.length > 0) {
            const { lv3List } = data
            l3 =
                lv3List
                    ?.filter(item => {
                        return second.includes(item.partnerName)
                    })
                    ?.map(item => item.name) ?? []
        }
        ReactDOM.unstable_batchedUpdates(() => {
            setLv2(Array.from(new Set(l2)))
            setLv3(Array.from(new Set(l3)))
        })
    }

    const fetchData = async () => {
        if (!queryType) {
            return
        }

        try {
            const { data, success } = await queryCategoryGroupItem({ queryType })
            if (success) {
                const [l1, l2, l3] = defaultCascade(data)
                ReactDOM.unstable_batchedUpdates(() => {
                    setData(data)
                    setLv1(l1)
                    setLv2(l2)
                    setLv3(l3)
                })
            } else {
                console.error('查询类目出错')
            }
        } catch (e) {
            console.error(e)
        }
    }
    useEffect(() => {
        fetchData()
    }, [queryType])

    useEffect(() => {
        if (data) {
            filterData()
        }
    }, [first, second])

    return [lv1, lv2, lv3]
}
